const development = {
  api: {
    uri: 'https://api.frolight.test:3000'
  }
};

const production = {
  api: {
    uri: 'https://api.frolight.com'
  }
};

const common = {
  i18n: {
    defaultLocale: 'en-GB'
  },
  debugging: {
    sentry: {
      dsn: 'https://7e4f5779eca54adb42c5885711d46a0c@o4509122348449792.ingest.de.sentry.io/4509122351857744'
    }
  }
};

let envConfig;
switch (process.env.NODE_ENV) {
  case 'development':
    envConfig = development;
    break;
  case 'production':
    envConfig = production;
    break;
  default:
    envConfig = development;
    break;
}

export default {
  ...common,
  ...envConfig
};
